import type { ExtensionViewSurface } from "@sylviq/ui-react-web/blocks/extension";
import { localNavigationPath } from "./extension-navigation";

type Scope = { organization_id: string; legal_entity_id: string };

function scopeNode(
  node: ExtensionViewSurface["body"],
  scope: Scope,
): ExtensionViewSurface["body"] {
  switch (node.type) {
    case "link":
      return node.href.startsWith("/") && !node.href.startsWith("//")
        ? { ...node, href: localNavigationPath(node.href, scope) }
        : node;
    case "stack":
    case "grid":
    case "card":
      return {
        ...node,
        children: node.children.map((child) => scopeNode(child, scope)),
      };
    case "hero":
      return node.actions
        ? {
            ...node,
            actions: node.actions.map((child) => scopeNode(child, scope)),
          }
        : node;
    default:
      return node;
  }
}

export function scopeExtensionViewSurface(
  surface: ExtensionViewSurface,
  scope: Scope,
): ExtensionViewSurface {
  return { ...surface, body: scopeNode(surface.body, scope) };
}
